import './ConversationChatbox.css';
function ConversationChatbox({ messages }) {
    const formatTime = (dateString) => {
        const [, time] = dateString.split('T');
        return time.split('.')[0];
    };

    return (
        <div className='conversation_chatbox_main_container'>
            <div className='conversation_content'>
                {messages && messages.map(({ human, content, is_hidden }, index) => {
                    return (
                        is_hidden == 0 && (index == messages.length - 1 || messages[index + 1].is_hidden != 1) &&

                        <div key={index} className={"conversation_bubble_conv " + (human == 0 ? 'conversation_bubble_bot_conv' : 'conversation_bubble_human_conv')}>
                            <div>{content}</div>
                            <div className="conversation_meta">
                                {human == 1 ? 'Human' : 'Bot'} - {formatTime(messages[index].created_at)}
                            </div>
                        </div>

                    )
                })}
            </div>
        </div>
    )
}

export default ConversationChatbox;